import FormControl from "@material-ui/core/FormControl";
import { withStyles } from "@material-ui/core/styles";
import React, { Component } from "react";
import Dropdown from "../FormElement/Dropdown";
import * as ticketActions from "../../modules/ticket/action";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
const styles = theme => ({
  buttonText: {
    "& fieldset": {
      borderColor: "transparent !important",
      borderBottom: "1px solid #ccc !important",
      borderRadius: "0"
    }
  },
  formControl: {
    minWidth: 200
  },
  iconDrop: {
    display: "none"
  },
  mainRoot: {
    padding: "5px 14px"
  },
  menuOption: {
    "& a": {
      // color: 'red',
      textDecoration: "underline"
    }
  }
});

class PreviousDaysForFarmsDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      SubFarmId: "",
      harvestYearLists: "",
      selectedPreviousDays: this.props.previousDaysvalue,
      PreviousDays:[
       {name: "Last 7 Days",id :7},
         {name:"Last 3 Months",id:90},
       {name: "All", id:100000}
   ]
    };
  }

  handleChange = event => {
    const { value } = event.target;
    this.setState({selectedPreviousDays:value})
    this.props.actions.setPreviousDaysFarmsAction(value);
  };
  render() {
    const { PreviousDays, selectedPreviousDays } = this.state;
    const {
      classes,
      route: { match }
    } = this.props;
    

    const isDisabled =
      match &&
      (match.path === "/harvestYearList" ||
        match.path === "/app/createticket" ||
        match.path === "/app/editTicket" ||
        match.path === "/app/createcontract" ||
        match.path === "/app/editcontract" ||
        match.url === "/settings/mandatory-fields" ||
        match.url === "/userManagement/edit" ||
        match.url === "/app/dashboard" ||
        match.url === "/app" ||
        match.url === "/reports" ||
        match.url === "/reconciliation" ||
        match.url === "/settings/mandatory-fields/contract")
        ? true
        : false;

    return (
      <FormControl variant="outlined" className={classes.formControl}>
        <Dropdown
          value={selectedPreviousDays}
          isClearable={false}
          disabled={isDisabled}
          handleChange={this.handleChange}
          options={PreviousDays.map(item => ({
            name: item.name,
            id: item.id
          }))}
        />
      </FormControl>
    );
  }
}


function mapStateToProps(state, props) {
  return {
    TicketList: state.ticketReducer.TicketList,
    previousDaysvalue: state.ticketReducer.previousDaysvalue
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...ticketActions,
      },
      dispatch
    )
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PreviousDaysForFarmsDropdown));



// WEBPACK FOOTER //
// ./src/components/Common/PrevioustDaysforFarmsAdded.js